import { AbstractDialogComponent } from './abstract-dialog.component';
import { Country, CountryService } from '../country';
import { City, CityService } from '../city';
import { AlertService } from 'ng-jhipster';
import { SchoolService } from '../school';
import { Principal } from '../../shared';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Tax, TaxService } from '../tax';

export abstract class AbstractGeograpicalDialogComponent extends AbstractDialogComponent {

    protected countries: Country[];
    protected loadingCountries: boolean = false;
    protected cities: City[];
    protected loadingCities: boolean = false;
    protected defaultCountryId: number;
    protected loadingTaxes: boolean = false;
    protected taxes: Tax[];

    constructor(
        protected countryService: CountryService,
        protected cityService: CityService,
        protected taxService: TaxService,
        protected schoolService: SchoolService,
        alertService: AlertService,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
    }

    protected loadGeographicalLocations(countryId: number) {
        let query = countryId != null ? 'country.id:' + countryId : '';
        if (countryId) {
            this.loadingCities = true;
            this.cityService
            .search({
                query: query
            }).subscribe(
            (res: HttpResponse<City[]>) => {
                this.cities = res.body;
                 this.sortCities(res.body);
                 this.loadingCities = false;
            },
            (res: HttpErrorResponse) => this.onError(res));

            this.loadingTaxes = true;
            this.taxService
            .query().subscribe(
            (res: HttpResponse<Tax[]>) => {
                this.taxes = res.body;
                 this.filterAndSortTaxes(countryId, res.body);
                 this.loadingTaxes = false;
            },
            (res: HttpErrorResponse) => this.onError(res));

        }
        this.loadingCountries = true;
        this.countryService.query({
            sort: ['name']
        }).subscribe(
            (res: HttpResponse<[Country]>) => {
                this.countries = res.body;
                this.loadingCountries = false;
            }, (res: HttpErrorResponse) => this.onError(res));
    }

    protected loadGeographicalLocationsNoAuth(form: NgForm) {
        this.loadingCountries = true;
        this.countryService.queryNoAuth({
            sort: ['name']
        }).subscribe(
            (res: HttpResponse<[Country]>) => {
                this.countries = res.body;
                this.loadingCountries = false;
                if (form) {
                    let index = this.countries.findIndex(c => c.name === 'France');
                    if (index !== -1) {
                        form.controls['country'].setValue(this.countries[index].id);
                    }
                }
            }, (res: HttpErrorResponse) => this.onError(res));
    }

    protected sortCities(cities: City[]) {
        if (cities) {
            this.cities = cities.sort((a: City, b: City) =>
                        a && a.name.localeCompare(b.name));
        }
    }

    protected filterAndSortTaxes(countryId: number, taxes: Tax[]) {
        // TODO remove this method, this is a workaround because the taxes are not in the index, because they have been created
        // Via script on the database and not in the UI. In this class, we must search using the index, to avoid
        // requesting all taxes
        if (taxes) {
            let countryTaxes = taxes.filter(tax => tax.country.id === countryId);
            this.taxes = countryTaxes.sort((a: Tax, b: Tax) =>
                        a && a.code.localeCompare(b.code));
        }
    }

    protected onCountryChange(countryId: number, form: NgForm, loadCities: boolean = true, loadTaxes: boolean = true) {
        if (loadCities) {
            this.loadingCities = true;
            this.cityService
                .search({
                    query: 'country.id:' + countryId
                }).subscribe(
                (res: HttpResponse<City[]>) => {
                    this.cities = res.body;
                    this.sortCities(res.body);
                    this.loadingCities = false;
                    form.controls['city'].setValue(this.cities[0].id);
                    },
                (res: HttpErrorResponse) => this.onError(res));
        }
        if (loadTaxes) {
            this.loadingTaxes = true;
            this.taxService
                .query().subscribe(
                (res: HttpResponse<Tax[]>) => {
                    this.taxes = res.body;
                    this.filterAndSortTaxes(countryId, res.body);
                    this.loadingTaxes = false;
                    if (form.controls['defaultTax'] && this.taxes.length > 0) {
                        form.controls['defaultTax'].setValue(this.taxes[0].id);
                    }
                },
                (res: HttpErrorResponse) => this.onError(res));
        }
    }

    protected onCountryChangeNoAuth(countryId: number, form: NgForm) {
        this.loadingCities = true;
        this.cityService
            .searchNoAuth({
                query: 'country.id:' + countryId
            }).subscribe(
            (res: HttpResponse<City[]>) => {
                this.cities = res.body;
                this.sortCities(res.body);
                this.loadingCities = false;
                form.controls['city'].setValue(this.cities[0].id);
                },
            (res: HttpErrorResponse) => this.onError(res));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/abstract-dialog-component/abstract-geopraphical-dialog.component.ts